import React from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import FormCliente_CF from "./FormCliente_CF";
//import { useTranslation } from "react-i18next";

function FormCliente({
  handleFieldChange,
  datiCliente,
  listaNazioni,
  errors,
  t,
  ...props
}) {
  //const { i18n, t } = useTranslation();

  return (
    <Form>
      <Form.Input
        fluid
        label={t("nome")}
        placeholder={t("nome")}
        name="nome"
        onChange={handleFieldChange}
        value={datiCliente.nome}
        error={
          errors.nome
            ? {
                content: t("nome_error"),
                pointing: "below",
              }
            : null
        }
      ></Form.Input>
      <Form.Input
        fluid
        label={t("cognome")}
        placeholder={t("cognome")}
        name="cognome"
        onChange={handleFieldChange}
        value={datiCliente.cognome}
        error={
          errors.cognome
            ? {
                content: t("cognome_error"),
                pointing: "below",
              }
            : null
        }
      ></Form.Input>
      <Form.Dropdown
        fluid
        label={t("nazione")}
        selection
        options={listaNazioni}
        placeholder={t("nazione")}
        name="nazione"
        onChange={handleFieldChange}
        value={datiCliente.nazione}
        search
        error={
          errors.nazione
            ? {
                content: t("nazione_error"),
                pointing: "below",
              }
            : null
        }
      />

      {props.datiScuola.usaCodiceFiscale === true && (
        <FormCliente_CF
          t={t}
          errors={errors}
          nazione={datiCliente.nazione}
          onFieldChange={handleFieldChange}
          cf={datiCliente.cf}
          dataNascita={datiCliente.dataNascita}
          luogoNascita={datiCliente.luogoNascita}
        />
      )}

      <Form.Group>
        <Form.Input
          fluid
          label={t("citta")}
          width={10}
          placeholder={t("citta")}
          name="citta"
          onChange={handleFieldChange}
          value={datiCliente.citta}
          error={
            errors.citta
              ? {
                  content: t("citta_error"),
                  pointing: "below",
                }
              : null
          }
        ></Form.Input>
        <Form.Input
          fluid
          label={t("cap")}
          width={6}
          placeholder={t("cap")}
          name="cap"
          onChange={handleFieldChange}
          value={datiCliente.cap}
          // error={
          //   errors.cap
          //     ? {
          //         content: t("cap_error"),
          //         pointing: "below",
          //       }
          //     : null
          // }
        ></Form.Input>
      </Form.Group>
      <Form.Input
        fluid
        label={t("indirizzo")}
        placeholder={t("indirizzo")}
        name="indirizzo"
        onChange={handleFieldChange}
        value={datiCliente.indirizzo}
        error={
          errors.indirizzo
            ? {
                content: t("indirizzo_error"),
                pointing: "below",
              }
            : null
        }
      ></Form.Input>
      <Form.Input
        fluid
        label={t("email")}
        placeholder={t("email")}
        name="email"
        onChange={handleFieldChange}
        value={datiCliente.email}
        error={
          errors.email
            ? {
                content: t("email_error"),
                pointing: "below",
              }
            : null
        }
      ></Form.Input>
      <Form.Input
        fluid
        label={t("cellulare")}
        placeholder={t("cellulare")}
        name="telefono"
        onChange={handleFieldChange}
        value={datiCliente.telefono}
        error={
          errors.telefono
            ? {
                content: t("cellulare_error"),
                pointing: "below",
              }
            : null
        }
      ></Form.Input>
    </Form>
  );
}

FormCliente.propTypes = {
  handleFieldChange: PropTypes.func.isRequired,
  datiCliente: PropTypes.object.isRequired,
  listaNazioni: PropTypes.array.isRequired,
  errors: PropTypes.object.isRequired,
  datiScuola: PropTypes.object.isRequired,
};

export default FormCliente;
